/**
 * @generated SignedSource<<7223e4e70e2485abc448ead2b2fd95ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotificationsMarkAllAsRead_viewer$data = {
  readonly userNotifications: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetAllUnreadNotifications_userNotifications">;
  } | null;
  readonly " $fragmentType": "UserNotificationsMarkAllAsRead_viewer";
};
export type UserNotificationsMarkAllAsRead_viewer$key = {
  readonly " $data"?: UserNotificationsMarkAllAsRead_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserNotificationsMarkAllAsRead_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserNotificationsMarkAllAsRead_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "UserNotifications",
      "kind": "LinkedField",
      "name": "userNotifications",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetAllUnreadNotifications_userNotifications"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bf4cc0ac268490e14b0242d3e47da6a8";

export default node;
